import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const ITEMS = [
  {
    q: "How much is a membership at the Longevity Lounge?",
    a: "$300/month on a recurring auto-renew membership. $350 for a single non-recurring month. Each includes daily PEMF + Red Light bookings, the Infinity Massage Chair, the Recovery Zone, herbal teas, and discounted HBOT. Ask about our VIP membership for the next level.",
  },
  {
    q: "What's included with the monthly membership?",
    a: "Daily PEMF and Red Light bookings, plus discounted HBOT — 60 min at $129 (normally $169) and 90 min at $159 (normally $199). The Infinity 3D massage chair, Therabody RecoveryAir compression boots, foam rollers, acupressure mats, and herbal teas of the day are included.",
  },
  {
    q: "What is the cost of a hyperbaric oxygen therapy (HBOT) session?",
    a: "For members: 60 min $129, 90 min $159. For non-members: 60 min $169, 90 min $199. HBOT is booked separately — call or text 808.500.8857.",
  },
  {
    q: "How long is each HBOT session and how often are they offered?",
    a: "HBOT sessions last 60 to 90 minutes and are offered from 8am to 5pm in limited time slots. Please refer to our booking system to choose a time that works.",
  },
  {
    q: "How often can I use the PEMF and red light therapy?",
    a: "Members can book one PEMF session and one red light session per day. Sessions must be reserved in advance through the Mindbody App.",
  },
  {
    q: "Can I bring a guest with me to a session?",
    a: "For safety and privacy, only scheduled members or paying clients are allowed in the lounge. Please review our Code of Conduct for full guest policies.",
  },
  {
    q: "Are there contraindications I should be aware of?",
    a: "Yes. All users must review the posted contraindications before each therapy. These include — but are not limited to — eye conditions, pregnancy, and implanted medical devices. Full details are in our Lounge Code of Conduct.",
  },
  {
    q: "How do I book a session?",
    a: "PEMF and red light are booked via the Mindbody App — log in, select FuzionFit, and use the Appointments tab. HBOT must be booked in person or by phone at 808.500.8857 (call or text).",
  },
  {
    q: "What happens if I miss my scheduled appointment?",
    a: "Missed appointments may result in a no-show fee or loss of session credit. Please give advance notice if you need to cancel — full cancellation policy is in our Code of Conduct.",
  },
  {
    q: "What are the lounge rules during my visit?",
    a: "The lounge is a phone-free, quiet zone to promote deep relaxation. No food, photography, or loud conversations. Refer to our Code of Conduct for the full set of wellness-centered guidelines.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-bone py-24 sm:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12 sm:mb-16 mll-reveal">
          <div className="lg:col-span-5">
            <p className="text-[11px] uppercase tracking-[0.28em] font-semibold text-clay">
              Questions, gently answered
            </p>
            <h2 className="mt-4 font-serif font-medium text-4xl sm:text-5xl lg:text-6xl tracking-tight text-stone leading-[1.05]">
              Frequently asked.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pl-10 flex lg:items-end">
            <p className="text-base sm:text-lg text-muted-ink leading-relaxed max-w-xl">
              Most of what people want to know before their first session.
              Anything we missed? Call or text the lounge directly — we read
              every message.
            </p>
          </div>
        </div>

        <div className="mll-reveal">
          <Accordion
            type="single"
            collapsible
            className="border-t border-stone/15"
            data-testid="faq-accordion"
          >
            {ITEMS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-stone/15 group"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-7 sm:py-9 hover:no-underline text-left font-serif text-xl sm:text-2xl text-stone group-hover:text-jungle transition-colors [&>svg]:hidden"
                >
                  <span className="flex items-baseline gap-6 sm:gap-8">
                    <span className="text-clay text-sm font-sans font-semibold tracking-wider">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="leading-snug">{item.q}</span>
                  </span>
                  <span className="ml-4 inline-flex items-center justify-center w-8 h-8 border border-stone/30 text-stone group-data-[state=open]:bg-jungle group-data-[state=open]:text-bone group-data-[state=open]:border-jungle transition-colors text-base font-light shrink-0">
                    <span className="group-data-[state=open]:hidden">+</span>
                    <span className="hidden group-data-[state=open]:inline">
                      −
                    </span>
                  </span>
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="pb-8 sm:pb-10 text-base sm:text-lg text-muted-ink leading-relaxed pl-10 sm:pl-14 max-w-3xl"
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
